import state from './modulePlanManagementState';
import mutations from "./modulePlanManagementMutations";
import actions from "./modulePlanManagementActions";

export default {
  namespaced: true,
  state: state,
  mutations,
  actions,
}
